// hooks/useFileProcess.js
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { processFileThunk } from "../store/slices/fileSlice"; // adjust path if needed
import { setActiveStep, setTotalSteps } from "../store/slices/fileSlice";

/**
 * Simulated multi-step processing flow (quick fallback).
 * This drives activeStep through 1..4 while dispatching the real processFileThunk.
 */
export default function useFileProcess(globalDispatch, navigate) {
  // If you pass dispatch from parent, prefer it, else create one
  const reduxDispatch = useDispatch();
  const dispatch = globalDispatch || reduxDispatch;

  const handleFileProcess = useCallback(
    async (uploadedFilePath, formValues = {}) => {
      // configure number of steps
      const TOTAL = 4;
      dispatch(setTotalSteps(TOTAL));

      try {
        // step 1: Data loaded successfully (upload typically sets this already)
        dispatch(setActiveStep(1));

        // Kick off the real processing thunk in parallel
        // (we don't await it yet so UI steps can show while server works)
        const file_name = typeof uploadedFilePath === "string"
          ? uploadedFilePath.split(/[\\\/]/).pop()
          : "";
        const processPromise = dispatch(
          processFileThunk({ file_name, ...formValues })
        ).unwrap();

        // Await the real backend process (no artificial delays)
        dispatch(setActiveStep(2));
        await processPromise;

        // ensure UI marks finished
        dispatch(setActiveStep(TOTAL));

        // navigate after processing fully completes
        if (typeof navigate === "function") {
          navigate("/dashboard/upload-result");
        }
      } catch (err) {
        // in case of real process error, leave activeStep as-is so modal shows where it failed
        console.error("Simulated process flow error:", err);
        // const message =
        //   typeof err === "string" ? err : err?.message || "Submit failed!";
        // toast.error(message);
        throw err;
      }
    },
    [dispatch]
  );

  return { handleFileProcess };
}
